<template>
  <div :class="['feedbacks']">
    <div class="feedback-full">
      <h3>Feedback Summary for {{ feedback.created_date }}</h3> 
      <div class="feedback-text" v-html="formattedSummary"></div> 
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedbackSummaryItem",
  props: {
    feedback: {
      default() {
        return {};
      },
      type: Object
    },
    propertyId: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      searchKeywords: ""
    };
  },
  computed: {
    property() {
      return this.$store.getters.property;
    },
    formattedSummary() {
      return this.feedback.summary.replace(/\n/g, '<br>');
    }
  },
  methods: {
     formatDate(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const dd = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const ss = String(date.getSeconds()).padStart(2, '0');

      return `${mm}-${dd}-${yyyy}`;
    },
     removeTime(dateString) {
      const parts = dateString.split(' ');
      // Take the relevant parts of the string array and join them with spaces
      const dateWithoutTime = `${parts[0]} ${parts[1]} ${parts[2]} ${parts[3]}`;
      return dateWithoutTime;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.feedbacks {
  padding: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border: 1px solid #cfe1f6;
  border-radius: 4px;
  lost-utility: clearfix;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
.positive-color-border {
  border-color: #33a878;
  border-width: 2px;
}
.negative-color-border {
  border-color: #df6358;
  border-width: 2px;
}
.neutral-color-border {
  border-color: #e7e5e0;
}
.empty-color-border {
  border-color: #e4e3e1;
}
.feedback-full {
  width: 100%;
  min-height: 280px;
  padding: 10px;
  font-size: 22px;
  float: left;
  position: relative;
  lost-utility: clearfix;
}
.feedback-rating {
  margin: 0 auto;
  width: 100px;
  text-align: center;
}
.sentiment-icons {
  text-align: center;
  display: block;
}
.sentiment-icons img {
  width: 30px;
  padding-top: 5px;
}
.feedback-text {
  display: block;
}
b {
  font-weight: bold;
}
.feedback-date {
  margin-top: 20px;
  float: left;
  width: 100%;
  font-size: 16px;
}
.categories {
  display: block;
}
.feedbacks b {
  font-weight: bold;
}
/* Clear floats after the columns */
.feedbacks:after {
  content: "";
  display: table;
  clear: both;
}

@media (max-width: 760px) {
  .feedback-rating {
    width: 100%;
  }
  .feedback-date {
    width: 100%;
  }
}
</style>
